import flagKeys from '@/constants/flagKeys';
import ManageTeam from '@/views/Settings/ManageTeam.vue';

import { Route } from '../route.model';

const manageTeam = new Route('/settings/team', 'settings-team', ManageTeam, {
  requiresAuth: true,
  onlyManager: true,
  isResponsive: flagKeys.responsiveDashboard,
  zendesk: {
    mobile: {
      offsetVertical: '102px'
    }
  },
  navbar: {
    name: 'Manage Team',
    icon: 'invite-customers'
  },
  pageView: {
    eventLabel: 'Manage Team'
  }
});

export { manageTeam };
export default manageTeam;
